export default {
  computed: {
    // La seccion activa puede llegar despues de la ruta: una cotizacion no sabe si es de
    // Cotizaciones o de Mis compras hasta que carga.
    activeNavLink() {
      return this.$store.getters['app/activeNavLink']
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.updateIsActive()
      },
    },
    activeNavLink() {
      this.updateIsActive()
    },
  },
}
